import { Reducer } from 'redux';
import { set } from 'lodash/fp';

import { adjustFooterLinksAction, adjustFooterLinksPayload, setVisibilityAction } from '../../actions/footer';
import { FOOTER_ADJUST_FOOTER_LINKS, FOOTER_SET_VISIBILITY } from '../../actions/action-types';

type FooterState = {
  adjustFooterLinks: adjustFooterLinksPayload;
  isVisible?: boolean;
};

type FooterAction = adjustFooterLinksAction | setVisibilityAction;

const initialState: FooterState = {
  adjustFooterLinks: { adjustedHeight: 0, isAdjusted: false },
};

const footerReducer: Reducer<FooterState, FooterAction> = (
  // eslint-disable-next-line default-param-last -- this is a conflict between eslint and redux
  state = initialState,
  action,
): FooterState => {
  const reducers = {
    [FOOTER_ADJUST_FOOTER_LINKS]: () => {
      const { payload } = action as adjustFooterLinksAction;
      return set('adjustFooterLinks', payload, state);
    },

    [FOOTER_SET_VISIBILITY]: () => {
      const { payload } = action as setVisibilityAction;
      return set('isVisible', payload, state);
    },
  };

  const reducer = reducers[action.type as keyof typeof reducers];
  return reducer ? reducer() : state;
};

export default footerReducer;
